import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function alertErrorMessage(message?: string): void {
  toast.error(message ? message.toUpperCase() : 'NETWORK ERROR...PLEASE TRY AGAIN LATER', {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
    closeButton: false,
  });
}

function alertSuccessMessage(message?: string): void {
  toast.success(message ? message.toUpperCase() : 'SUCCESS', {
    position: 'top-center',
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
    closeButton: false,
  });
}

function alertWarningMessage(message?: string): void {
  toast.info(message ? message.toUpperCase() : 'OOPS...SOMETHING WENT WRONG', {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  });
}

export { alertErrorMessage, alertSuccessMessage, alertWarningMessage };